// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entities-list-container {
  padding: 2rem;
  background-color: white;
}
.entities-list-container h6 {
  margin-bottom: 1rem;
  margin-top: 3rem;
}

.section-tabGroup {
  display: flex;
  justify-content: center;
}
.section-tabGroup mat-tab-group {
  width: 95%;
}

.accordion-active {
  margin-top: 32px;
  border-bottom: 1px rgb(174, 15, 10) solid;
}

.accordion-inactive {
  margin-top: 32px;
  border-bottom: 1px #706F6F solid;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/afericoes/afericao-servico/afericao-servico.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;AACF;AACE;EACE,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;AACJ;AAAI;EACI,UAAA;AAER;;AACA;EACE,gBAAA;EACA,yCAAA;AAEF;;AAAA;EACE,gBAAA;EACA,gCAAA;AAGF","sourcesContent":[".entities-list-container {\n  padding: 2rem;\n  background-color: white;\n\n  h6 {\n    margin-bottom: 1rem;\n    margin-top: 3rem;\n  }\n}\n.section-tabGroup{\n    display: flex;\n    justify-content: center;\n    mat-tab-group{\n        width: 95%;\n    }\n}\n.accordion-active{\n  margin-top: 32px;\n  border-bottom: 1px rgb(174, 15, 10) solid;\n}\n.accordion-inactive{\n  margin-top: 32px;\n  border-bottom: 1px #706F6F solid;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
